<template>
    <div id="individual-plans">

        <p class="plan_title">{{ plan.title }}</p>

        <div class="ech-row" id="plan-spec-slider">
            <div id="plan-specs">
                <h2>Plan Specs</h2>
                <ul id="specs">
                    <li v-for="spec in plan.specs">{{ spec }}</li>
                </ul>
                <ul id="sizes">
                    <li v-for="size in plan.sizes">{{ size }}</li>
                </ul>
                <a :href="plan.flyer" id="get_brochure" target="_blank">Get Flyer</a>
            </div>
            <div id="plan-slider">
                <img :src="renderPlanImage" alt="">
            </div>
        </div>

        <div class="ech-row row-2">
            <div id="floor-plan-slider">
                <carousel :autoplay="false" :per-page="1" :autoplay-timeout="4000" :autoplay-hover-pause="true"
                          :navigation-click-target-size="0" :loop="true">

                    <slide v-for="(floor, i) in loadFloorPlans" :key="i">
                        <img :src="floor.src"
                             :alt="'Floor plan ' + floor.name" @click="plan.showPlan = true" style="cursor: pointer;">
                    </slide>
                </carousel>
            </div>
            <div id="options">
                <div id="interior">
                    <h2>Interior Options</h2>
                    <ul>
                        <li v-for="option in plan.interiorOptions">{{ option }}</li>
                    </ul>
                </div>
                <div id="exterior">
                    <h2>Exterior Options</h2>
                    <ul>
                        <li v-for="option in plan.exteriorOptions">{{ option }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <v-layout align-center justify-center>
            <v-flex>
                <v-dialog v-model="plan.showPlan" :max-width="800">
                    <v-card>
                        <v-card-title primary-title class="modal-title">
                            <div class="download-floor-plan">
                                <span>{{ plan.title }} Floor Plans</span>
                                <v-spacer></v-spacer>
                                <a :href="plan.floorPlanPdf" target="_blank">
                                    Download</a>
                            </div>
                        </v-card-title>
                        <v-card-text class="modal-img">
                            <carousel :autoplay="false" :per-page="1" :autoplay-timeout="4000" :autoplay-hover-pause="true"
                                      :navigation-click-target-size="0" :loop="true"
                                      :navigation-next-label='`<i class="fas fa-arrow-right fa-2x nav-arrows"></i>`'
                                      :navigation-prev-label='`<i class="fas fa-arrow-left fa-2x nav-arrows"></i>`'>
                                <slide v-for="(floor, i) in loadFloorPlans" :key="i">
                                    <img :src="floor.src"
                                         :alt="'Floor plan ' + floor.name">
                                </slide>
                            </carousel>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>

        <div id="communities">
            <p class="community_title">Available in These Communities:</p>
            <div class="community" v-for="(community, i) in plan.availableCommunities" :key="i"
                 v-if="community.disabled === false">
                <router-link tag="img" :to="{ path: '/communities/' + community.community_name}"
                             :src="community.thumbnail"></router-link>

                <div>
                    <p>{{ community.title }}</p>
                    <p>City: {{ community.city }}</p>
                    <p>Acres: {{ community.acres }}</p>
                    <p>Available Lots: {{ community.lots }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import pdf from 'vue-pdf'

    const apiToken = require('../../../credentials').API_TOKEN;
    const urlPath = require('../../../credentials').URL_PATH;
    const data = {
        plan: {
            planName: '',
            title: '',
            imageFolder: 'https://elitecrafthomes.com/static_files/images',
            specs: [],
            sizes: [],
            interiorOptions: [],
            exteriorOptions: [],
            availableCommunities: [],
            floorPlans: [],
            floorPlanPdf: '',
            floorPlanImages: [],
            thumbnail: '',
            dialog: false,
            pdf: {
                currentPage: 1,
                pageCount: ''
            },
            showPlan: false,
            showPlans: [],
            planImages: [],
            locations: []
        }
    };

    export default {
        name: 'Plan',
        components: {
            pdf
        },
        data() {
            return data;
        },
        computed: {
            renderPlanImage() {
                if (this.plan !== undefined && this.plan !== 'undefined') {
                    return this.plan.planImages.src;
                }
            },
            loadFloorPlans() {
                if (this.plan !== undefined && this.plan !== 'undefined') {
                    return this.plan.floorPlanImages;
                }
            }
        },
        methods: {
            prevPage() {
                if (this.plan.pdf.currentPage > 1) {
                    this.plan.pdf.currentPage -= 1;
                    return true
                } else {
                    return false;
                }
            },
            nextPage() {
                if (this.plan.pdf.currentPage < this.plan.pdf.pageCount) {
                    this.plan.pdf.currentPage += 1;
                    return true;
                } else {
                    return false;
                }
            },
            parseFloorPlanTitle(data) {
                let planName = data.plan[0].toUpperCase() + data.plan.slice(1, data.plan.length);
                if (data.image_name.includes("main")) {
                    return  planName + " Main Floor";
                } else if (data.image_name.includes("basement")) {
                    return planName + " Basement Floor";
                } else if (data.image_name.includes("upper")) {
                    return planName + " 2nd Floor";
                } else {
                    return planName + ' Floor';
                }
            },
            hydratePlan() {
                axios.get(urlPath + 'plans/plans/' + this.$route.params.name + '/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        // plan name
                        this.plan.planName = res.data.plan_name;
                        this.plan.title = res.data.title;
                        this.plan.thumbnail_src = res.data.thumbnail_src;
                        // specs
                        this.plan.specs = [];
                        this.plan.specs.push(res.data.bedrooms + ' Bedroom(s)');
                        this.plan.specs.push(res.data.bathrooms + ' Bathrooms(s)');
                        this.plan.specs.push(res.data.garages + ' Garage(s)');

                        // sizes
                        this.plan.sizes = [];
                        this.plan.sizes.push(res.data.total_size + ' Sq. Ft.');
                        this.plan.sizes.push(res.data.finished_size + ' Finished Sq. Ft.');
                        this.plan.sizes.push(res.data.basement_size + ' Basement Sq. Ft.');

                        // options
                        this.plan.interiorOptions = res.data.interior_finishes.slice(0, 5);
                        this.plan.exteriorOptions = res.data.exterior_finishes.slice(0, 5);

                        // location
                        this.plan.locations = res.data.locations;

                        // floor plan pdf
                        this.plan.floorPlanPdf = res.data.floor_plan_pdf_src;

                        // flyer pdf
                        this.plan.flyer = res.data.flyer_src;
                    })
            },
            hydrateCommunities() {
                axios.get(urlPath + 'communities/communities/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.plan.availableCommunities = [];
                        for (let i = 0; i < res.data.length; i++) {
                            for (let j = 0; j < res.data[i].plans.length; j++) {
                                if (res.data[i].plans[j] === this.plan.planName) {
                                    this.plan.availableCommunities.push({
                                        city: res.data[i].location.city,
                                        acres: res.data[i].acres,
                                        lots: res.data[i].available_lots,
                                        title: res.data[i].title,
                                        thumbnail: res.data[i].thumbnail_src,
                                        community_name: res.data[i].community_name,
                                        disabled: res.data[i].disabled
                                    })
                                }
                            }
                        }
                    });
            },
            hydrateFloorPlans() {
                axios.get(urlPath + 'plans/floorplans/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.plan.floorPlanImages = [];
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].plan === this.plan.planName) {
                                this.plan.floorPlanImages.push(res.data[i])
                            }
                        }
                    }, res => {
                        console.log('errors', res)
                    });
            },
            hydratePlanImages() {
                axios.get(urlPath + 'plans/images/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then(res => {
                        this.plan.planImages = [];
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].plan === this.plan.planName) {
                                this.plan.planImages = res.data[i];
                                break;
                            }

                        }
                    }, res => {
                        console.log('errors', res)
                    })
            }
        },
        created() {
            this.hydratePlan();
            this.hydrateCommunities();
            this.hydrateFloorPlans();
            this.hydratePlanImages();
        },
        mounted() {
            this.hydratePlanImages();
            this.hydrateFloorPlans();

        }
    }
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf");
    }

    .plan_title {
        margin-top: 15px;
        margin-bottom: 75px;
        text-align: center;
        font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
        font-size: 32px;

    }

    button:focus {
        outline: none;
    }

    .btn__content {
        line-height: 1;
    }

    a#get_brochure {
        font-size: 20px;
        border: 3px solid white;
        background-color: #425152;
        color: white;
        width: 175px;
        padding: 7px 20px;
        text-decoration: none;
        text-align: center;
        -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
        outline: none;
        font-weight: 600;
        cursor: pointer;
        z-index: 9;
    }

    .download_brochure {
        color: white;
        font-size: 20px;
        margin-left: 25px;
        text-decoration: none;
    }

    #individual-plans {
        margin: 0 auto;
        max-width: 1200px;
        background-color: white;
    }

    #plan-slider {
        width: 600px;
        height: 350px;
        text-align: center;
        margin-left: 35px;
        img {
            text-align: center;
            margin: 0 auto;
            max-width: 600px;
            width: 100%;
            height: 350px;
            max-height: 350px;
            object-fit: fill;
        }
    }

    .modal-title {
        background-color: #eee;
        max-width: 800px;
        width: 100%;
        .download-floor-plan {
            width: 100%;
            span {
                float: left;
                font-size: 18px;
            }
            a {
                float: right;
                text-align: right;
                text-decoration: none;
                font-size: 18px;
            }
        }
    }

    .modal-img {
        margin: 0 auto;
        text-align: center;
        img {
            width: 750px;
            height: 650px;
        }

    }

    #floor-plan-slider {
        width: 450px;
        height: 400px;
        img {
            height: 400px;
            max-height: 400px;
            width: 100%;
            max-width: 450px;
        }
    }

    #plan-specs ul {
        padding: 0 0 15px 0;
    }

    #plan-specs ul li {
        list-style-type: none;
    }

    #specs {
        li {
            margin: 10px 0;
            font-size: 18px;
        }
    }

    #sizes {
        li {
            font-size: 18px;
        }
    }

    #options {
        margin-left: 45px;
        width: 350px;
    }

    #exterior {
        margin-top: 15px;
    }

    .hero {
        width: 100%;
        height: 500px;

        display: flex;
        justify-content: center;
        align-items: center;

        background-size: cover;
    }

    /*.img {*/
    /*padding: 0 15px;*/
    /*width: 180px;*/
    /*height: 180px;*/
    /*}*/

    .ech-row {
        margin: 0 auto 100px auto;
        max-width: 899px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .ech-row h2 {
        text-decoration: underline;
    }

    @media screen and (min-width: 1025px) {
        #communities {
            clear: both;
            margin: 75px auto 100px auto;
            max-width: 1200px;
            width: 100%;
            position: relative;
            text-align: center;
            display: inline-block;
            p.community_title {
                text-align: left;
                font-size: 20px;
                padding-left: 50px;
                font-weight: 700;
            }
            .community {
                position: relative;
                max-width: 255px;
                width: 100%;
                max-height: 167px;
                height: 167px;
                display: inline-block;
                margin: 0 15px;
                img {
                    max-width: 255px;
                    width: 100%;
                    max-height: 167px;
                    height: 100%;
                    object-fit: fill;
                    cursor: pointer;
                }
                div {
                    margin-top: 10px;
                    p:nth-of-type(1) {
                        font-size: 22px;
                        padding-bottom: 10px;
                        font-weight: 600;
                    }
                    p:not(:nth-of-type(1)) {
                        font-weight: 400;
                        font-size: 16px;
                        padding: 0;
                        margin: 0;
                    }
                }
            }

        }
    }
    @media screen and (min-width: 451px) and (max-width: 768px) {
        .modal-title {
            background-color: #eee;
            max-width: 720px;
            width: 100%;
            .download-floor-plan {
                width: 100%;
                max-width: 720px;
                padding: 0;
                margin: 0;
                span {
                    float: left;
                    font-size: 18px;
                }
                a {
                    float: right;
                    text-align: right;
                    text-decoration: none;
                    font-size: 18px;
                }
            }
        }
        a#get_brochure {
            white-space: nowrap;
        }

        .modal-img {
            margin: 0 auto;
            text-align: center;
            img {
                max-width: 650px;
                max-height: 550px;
                width: 100%;
                height: 100%;
            }

        }

        #floor-plan-slider {
            max-width: 350px;
            max-height: 300px;
            img {
                height: 100%;
                max-height: 300px;
                width: 100%;
                max-width: 350px;
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        #individual-plans {
            padding: 0 10px;
        }

        a#get_brochure {
            white-space: nowrap;
        }

        #communities {
            padding: 0 10px;
            margin: 0 auto 50px auto;
            text-align: center;
            max-width: 600px;
            width: 100%;
            p.community_title {
                text-align: left;
                font-size: 20px;
                font-weight: 700;
            }
            .community {
                position: relative;
                max-width: 255px;
                width: 255px;
                height: 285px;
                display: inline-block;
                text-align: center;
                img {
                    max-width: 255px;
                    width: 255px;
                    max-height: 167px;
                    height: 167px;
                    object-fit: fill;
                }
                div {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    text-align: center;
                    margin: 0 auto;
                    a:nth-of-type(1) {
                        font-weight: 600;
                        font-size: 20px;
                        padding-bottom: 10px;
                        text-align: center;
                        text-decoration: none;
                        color: black;
                    }
                    p {
                        font-weight: 400;
                        padding: 0;
                        margin: 0;
                        text-align: center;
                    }
                }
            }
            .community:nth-child(even) {
                margin: 0 35px 35px 0;

            }

            .community:nth-child(odd) {
                margin: 0 0 35px 35px;
            }
        }

    }

    @media screen and (max-width: 450px) {
        .modal-title {
            background-color: #eee;
            max-width: 420px;
            width: 100%;
            .download-floor-plan {
                width: 100%;
                max-width: 420px;
                padding: 0;
                margin: 0;
                span {
                    float: left;
                    font-size: 18px;
                }
                a {
                    float: right;
                    text-align: right;
                    text-decoration: none;
                    font-size: 18px;
                }
            }
        }

        .modal-img {
            margin: 0 auto;
            text-align: center;
            img {
                max-width: 400px;
                max-height: 300px;
                width: 100%;
                height: 100%;
            }
        }

        #individual-plans {
            margin: 0;
            padding: 0;
            max-width: 100vw;
            width: 100%;
            .plan_title {
                font-size: 28px;
                margin: 25px auto 35px auto;
            }

            .ech-row {
                max-width: 100vw;
                width: 100%;
            }

            #plan-spec-slider {
                position: relative;
                height: 650px;
                max-width: 100vw;
                width: 100%;
                margin-bottom: 50px;
                #plan-specs {
                    padding: 0 10px;
                    width: 100%;
                    margin: 0 auto;
                    text-align: center;
                    h2 {
                        text-align: left;
                    }
                    #specs, #sizes {
                        text-align: left;
                        margin-bottom: 20px;
                        li {
                            padding: 0;
                            margin: 0;
                        }
                    }
                    #get_brochure {
                        text-align: center;
                        margin: 0 auto;
                        font-size: 18px;
                        padding: 10px 15px;
                    }
                }
                #plan-slider {
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin: 0;
                    padding: 0;
                    max-width: 100vw;
                    img {
                        position: absolute;
                        left: 50%;
                        -webkit-transform: translateX(-50%);
                        -moz-transform: translateX(-50%);
                        -ms-transform: translateX(-50%);
                        -o-transform: translateX(-50%);
                        transform: translateX(-50%);
                        text-align: center;
                        max-width: 100vw;
                        width: 100%;
                        height: 350px;
                        max-height: 350px;
                        object-fit: fill;

                    }
                }

            }

            .row-2 {
                position: relative;
                height: 830px;
                #floor-plan-slider {
                    max-width: 350px;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 50%;
                    -webkit-transform: translateX(-50%);
                    -moz-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    -o-transform: translateX(-50%);
                    transform: translateX(-50%);
                    /*margin: 0 auto;*/
                    img {
                        height: 100%;
                        max-height: 300px;
                        width: 100%;
                        max-width: 350px;
                    }
                }

                #options {
                    max-width: 80vw;
                    width: 100%;
                    position: absolute;
                    top: 450px;
                    margin-top: 25px;

                    #interior, #exterior {
                        max-width: 100%;
                        width: 100%;
                        padding: 0 10px;
                        li {
                            max-width: 100%;
                            width: 100%;

                        }
                    }
                }
            }

            #communities {
                margin: 50px auto 75px auto;
                max-width: 100vw;
                padding: 0 10px;
                p.community_title {
                    text-align: center;
                    padding-left: 0;
                    font-weight: 700;
                    font-size: 20px;
                }
                .community {
                    position: relative;
                    height: 150px;
                    width: auto;
                    max-width: inherit;
                    display: inherit;
                    margin: 0;

                    img {
                        max-width: 167px;
                        width: 167px;
                        max-height: 152px;
                        height: 152px;
                    }
                    div {
                        position: absolute;
                        width: 50vw;
                        top: 50%;
                        margin: 0;
                        -webkit-transform: translateY(-50%);
                        -moz-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        -o-transform: translateY(-50%);
                        transform: translateY(-50%);

                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            text-decoration: none;
                            color: black;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                }

                .community:nth-child(odd) {
                    img {
                        float: left;
                    }

                    div {
                        right: 0;
                        padding-left: 20px;
                        text-align: left;
                        a, p {
                            text-align: left;
                        }
                    }
                }

                .community:nth-child(even) {
                    img {
                        position: absolute;
                        right: 0;
                    }
                    div {
                        text-align: right;
                        left: 0;
                        padding-right: 20px;
                        a, p {
                            text-align: right;
                        }
                    }
                }
            }

        }

    }

</style>



// WEBPACK FOOTER //
// src/components/plans/IndividualPlan.vue